module.exports = __webpack_public_path__ + "34bc775d/img/settings-ico.a214628d.svg";